var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * SoundNone component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconSoundNone extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.8845 3.69099C13.5172 3.51554 13.11 3.44023 12.7043 3.47269C12.2985 3.50515 11.9085 3.64422 11.5737 3.87583L5.51882 8.12939H3.41624C2.80338 8.12939 2.21563 8.37285 1.78228 8.8062C1.34892 9.23956 1.10547 9.82731 1.10547 10.4402V13.5617C1.10547 14.1746 1.34892 14.7623 1.78228 15.1957C2.21563 15.629 2.80338 15.8725 3.41624 15.8725H5.51726L11.4222 20.1163L11.4333 20.124C11.768 20.3556 12.158 20.4947 12.5638 20.5271C12.9666 20.5594 13.3709 20.4854 13.7361 20.3126C14.131 20.1334 14.4676 19.8467 14.7072 19.4851C14.9485 19.1211 15.0817 18.6962 15.0914 18.2596L15.0916 18.243V5.76489C15.0997 5.35327 14.9976 4.9469 14.7959 4.58786C14.5926 4.22598 14.2956 3.92553 13.936 3.71811C13.9192 3.7084 13.902 3.69936 13.8845 3.69099ZM6.50739 14.7369L12.2914 18.8936C12.4078 18.973 12.5429 19.0207 12.6834 19.0319C12.8258 19.0433 12.9686 19.0169 13.0975 18.9553L13.1134 18.9479C13.2532 18.8851 13.3723 18.784 13.457 18.6563C13.5404 18.5306 13.587 18.3841 13.5916 18.2333V5.75683L13.5918 5.73897C13.5953 5.59338 13.5595 5.44953 13.4881 5.32256C13.4216 5.20407 13.3264 5.10435 13.2114 5.03241C13.0896 4.97952 12.9565 4.9573 12.8239 4.96791C12.6822 4.97925 12.5461 5.02759 12.429 5.1081L6.50739 9.26806V14.7369ZM2.84294 9.86686C2.99499 9.71481 3.20121 9.62939 3.41624 9.62939H5.00739V14.3725H3.41624C3.20121 14.3725 2.99499 14.2871 2.84294 14.135C2.69089 13.983 2.60547 13.7767 2.60547 13.5617V10.4402C2.60547 10.2251 2.69089 10.0189 2.84294 9.86686ZM22.6758 9.12738C22.9687 9.42028 22.9687 9.89515 22.6758 10.188L20.8649 11.9989L22.6758 13.8097C22.9687 14.1026 22.9687 14.5775 22.6758 14.8704C22.3829 15.1632 21.908 15.1632 21.6151 14.8704L19.8043 13.0595L17.9935 14.8704C17.7006 15.1632 17.2257 15.1632 16.9328 14.8704C16.6399 14.5775 16.6399 14.1026 16.9328 13.8097L18.7436 11.9989L16.9328 10.188C16.6399 9.89515 16.6399 9.42028 16.9328 9.12738C17.2257 8.83449 17.7006 8.83449 17.9935 9.12738L19.8043 10.9382L21.6151 9.12738C21.908 8.83449 22.3829 8.83449 22.6758 9.12738Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconSoundNone.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconSoundNone.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconSoundNone.prototype, "size", void 0);
if (customElements.get('cat-icon-sound-none') === undefined) {
    customElements.define('cat-icon-sound-none', BlocksIconSoundNone);
}
